<template>
  <div
    tile
    class="py-2x text-small font-weight-bold primary--text"
    style="
      padding-top: 5px;
      padding-bottom: 5px;
      border-bottom-left-radiusx: 3px;
      border-bottom-right-radiusx: 3px;
    "
  >
    <v-progress-circular
      :rotate="-90"
      :size="26"
      :width="2"
      :value="value"
      color="primary"
      style="font-size: 11px; margin-left: -5px; margin-right: 9px"
      class="px-0"
      >{{ timer }}</v-progress-circular
    >

    <span>Last updated : {{ formattedTimeNow }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UpdateTimer",
  components: {},
  data: () => ({
    interval: {},
    value: 100,
    timer: window.$settings.seatAvailRefreshIntervalInSeconds,
    formattedTimeNow: null,
  }),
  computed: {
    ...mapState(["dashboard"]),
  },
  methods: {
    updateLastUpdatedTime() {
      this.formattedTimeNow = this.time.nowMoment.format(
        "D MMM YYYY, h:mm:ss a"
      );
    },
    resetTimer() {
      this.timer = window.$settings.seatAvailRefreshIntervalInSeconds;
      this.value = 100;
    },
  },
  watch: {
    dashboard(newValue, oldValue) {
      if (newValue) {
        this.resetTimer();
        this.updateLastUpdatedTime();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.updateLastUpdatedTime();

    this.interval = setInterval(() => {
      const totalSeconds = window.$settings.seatAvailRefreshIntervalInSeconds;

      if (this.timer <= 0) {
        this.resetTimer();
      } else {
        this.timer -= 1;
        const timerPercentage = (1 / totalSeconds) * 100;
        this.value -= timerPercentage;

        if (this.timer === 0) {
          this.$emit("times-up");
          this.updateLastUpdatedTime();
        }
      }
    }, 1000);
  },
};
</script>